import { isVNode as _isVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
/**
 * @author zhouchangluan
 * @fileoverview 视频list
 */

import { defineComponent, toRefs, reactive, watch } from "vue";
import _ from "lodash";
// components
import playBtnUrl from "@/assets/img/race-video/m/play-btn.png";
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
export default defineComponent({
  name: "VideoList",
  props: {
    videoData: {
      type: Array,
      required: false,
      default: () => []
    },
    colSpan: {
      type: Number,
      required: false,
      default: 8
    },
    rowGutter: {
      type: Number,
      required: false,
      default: 20
    }
  },
  setup(props, {
    emit
  }) {
    const {
      videoData,
      colSpan,
      rowGutter
    } = toRefs(props);
    const state = reactive({
      videoData: videoData.value || []
    });

    // 监听资讯列表变化
    watch(() => props.videoData, val => {
      state.videoData = val;
    });

    // 点击视频item
    function clickVideoItemFct(item) {
      emit("clickVideoItem", item);
    }
    return () => {
      function buildVideoItem() {
        const videoItem = _.map(state.videoData, item => {
          return _createVNode(_resolveComponent("van-col"), {
            "class": "video-item-col",
            "span": colSpan.value,
            "onClick": () => clickVideoItemFct(item)
          }, {
            default: () => [_createVNode("div", {
              "class": "video-item"
            }, [_createVNode("img", {
              "class": "video-img",
              "src": item.image
            }, null), _createVNode("div", {
              "class": "video-info"
            }, [_createVNode("div", {
              "class": "video-title"
            }, [item.title]), _createVNode("div", {
              "class": "video-other-info"
            }, [_createVNode("img", {
              "class": "play-btn",
              "src": playBtnUrl
            }, null), _createVNode("span", {
              "class": "video-date"
            }, [item.published_time])])])])]
          });
        });
        return _createVNode(_resolveComponent("van-row"), {
          "gutter": rowGutter.value
        }, _isSlot(videoItem) ? videoItem : {
          default: () => [videoItem]
        });
      }
      return _createVNode("div", {
        "class": "video-list-box pc-exclude"
      }, [buildVideoItem()]);
    };
  }
});